// Central place to manage outbound contact (WhatsApp) link.
// Phone must be in E.164 format (country code + area code + number, no + or spaces).
export const WHATSAPP_PHONE = "5511994729734";
export const WHATSAPP_MESSAGE =
    "Olá! Gostaria de agendar uma avaliação na Oliva Implantes.";
export const WHATSAPP_URL = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
    WHATSAPP_MESSAGE,
)}`;

export const CLINIC = {
    name: "Oliva Implantes",
    tagline:
        "Excelência em Reabilitação Oral e Implantes Dentários",
    addressLine1: "Rua Frei Gaspar, 941",
    addressLine2: "Sala 405, Consultório 3",
    addressLine3: "Assunção — São Bernardo do Campo, SP",
    addressShort: "São Bernardo do Campo — SP",
    addressFull:
        "Rua Frei Gaspar, 941, Sala 405, Consultório 3, Assunção, São Bernardo do Campo — SP",
    email: "andre.oliva@unesp.br",
    phoneDisplay: "+55 (11) 99472-9734",
};
